import React from 'react'

const BuyAdvertisement = () => {
  return (
    <div style={{marginTop:"80px"}}>Buy Advertisement</div>
  )
}

export default BuyAdvertisement